import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '../store'
import { getToken } from '@/helpers'

Vue.use(VueRouter)

// Provides performance data to User Timing API
Vue.config.performance = true

const Router = new VueRouter({
  mode: process.env.VUE_APP_MODE === 'cordova' ? 'hash' : 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return {
        selector: to.hash,
      }
    }
    return { x: 0, y: 0 }
  },
  routes,
})

Router.beforeResolve(async (to, from, next) => {
  const token = await getToken()
  const isAdmin = store.getters['auth/isAdmin']

  if (token && to.name === 'login') {
    next({ name: 'home' })
  } else if (!token && to.name === 'user-dashboard') {
    next({ name: 'login' })
  } else if (!token && to.name === 'two-factor') {
    next({ name: 'login' })
  } else if (!isAdmin && to.name === 'admin') {
    next({ name: 'home' })
  } else {
    next()
  }
})

export default Router
